import { useMemo } from 'react';
import QRCode from 'qrcode';

/**
 * QR code as crisp SVG modules, navy on white with a 4 module quiet zone so
 * phone cameras pick it up off a screen. Level H survives glare and scratches.
 */
export function QrCode({ value, label }: { value: string; label: string }) {
  const { size, path } = useMemo(() => {
    const qr = QRCode.create(value, { errorCorrectionLevel: 'H' });
    const n = qr.modules.size;
    let d = '';
    for (let r = 0; r < n; r++) {
      for (let c = 0; c < n; c++) if (qr.modules.get(r, c)) d += `M${c + 4} ${r + 4}h1v1h-1z`;
    }
    return { size: n + 8, path: d };
  }, [value]);

  return (
    <svg
      viewBox={`0 0 ${size} ${size}`}
      role="img"
      aria-label={label}
      shapeRendering="crispEdges"
      className="block h-auto w-full rounded-2xl bg-white"
    >
      <path d={path} fill="#0B1220" />
    </svg>
  );
}
